export default __webpack_public_path__ + "static/media/excel@2024.7e23f0f6.svg";